module.exports = __webpack_public_path__ + "img/charging-hub-realized.cbb88d36.png";